<template>
  <div class="download-guide-ios">
    <h2 class="download-guide-ios-title">PlexVPN iOS版下载教程</h2>
    <div class="download-guide-ios-content">
      <div class="dgic-item">
        <img src="../../../static/img/downloadGuideIos/dgi_img_switch.jpg" alt="dgi-img-switch" class="dgic-item-img" />
        <div class="dgic-item-content">
          <h3 class="dgic-item-content-title">第 1 步：切换App Store中的AppleID为公共账号</h3>
          <div class="dgic-item-content-text">
            <p>打开App Store进行账号切换</p>
            <ul>
              <li>公共账号：</li>
              <li>苹果账户: plexv3@hotmail.com 密码: OfficialService1</li>
              <li>苹果账户: plexv6@outlook.com 密码: OfficialService6</li>
            </ul>
            <p>* 注：不要在 “ 个人设置 ” 中切换账号</p>
          </div>
        </div>
      </div>
      <div class="dgic-item">
        <img src="../../../static/img/downloadGuideIos/dgi_img_search.jpg" alt="dgi-img-search" class="dgic-item-img" />
        <div class="dgic-item-content">
          <h3 class="dgic-item-content-title">第 2 步：搜索找到PlexVPN并下载</h3>
          <div class="dgic-item-content-text">
            <p>在App Store中找到PlexVPN进行下载</p>
            <p>*注意：</p>
            <ol>
              <li>请务必认准如图所示官方正版PlexVPN进行下载使用</li>
              <li>使用公共账号下载完成后，请立即退出账号，否则手机会有被锁的风险</li>
              <li>
                若公共账号无法使用，您可以
                <router-link to="/region-tutorial-iOS" class="link-color">【修改自己AppleID的所属地区】</router-link>进行下载
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.state.currentLang;
    }
  },
  mounted() {
    if (this.language !== 'zh') {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.download-guide-ios {
  padding: 1.2rem 19% 1rem;
  font-size: 0.14rem;
  color: #fff;
  background-color: #160d37;
  .download-guide-ios-title {
    font-size: 0.32rem;
  }
  .download-guide-ios-content {
    margin-top: 0.5rem;
    .dgic-item {
      display: flex;
      justify-content: space-between;
      .dgic-item-img {
        width: 25%;
        border-radius: 24px;
        @media screen and (min-width: 769px) and (max-width: 1024px) {
          width: 130px;
          height: 245px;
        }
      }
      .dgic-item-content {
        width: 60%;
        .dgic-item-content-title {
          padding: 0.05rem 0.2rem;
          width: max-content;
          max-width: 100%;
          font-size: 0.16rem;
          background-color: #555;
          border-radius: 27px;
        }
        .dgic-item-content-text {
          margin-top: 0.3rem;
          ul {
            padding: 0;
            list-style: none;
          }
          ol {
            padding-left: 20px;
          }
        }
        .link-color {
          color: #6d3692;
        }
      }
    }
    .dgic-item ~ .dgic-item {
      margin-top: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0.4rem 0.3rem 0.8rem;
    .download-guide-ios-content {
      .dgic-item {
        flex-direction: column-reverse;
        .dgic-item-img {
          margin-top: 0.4rem;
          width: 100%;
          @media screen and (min-width: 600px) {
            margin: 0.4rem auto;
            width: 75%;
          }
        }
        .dgic-item-content {
          width: 100%;
          .dgic-item-content-text {
            margin-top: 0.2rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// downloadGuideIos.vue?2b7d24b1